import { gql } from "@apollo/client";
import { messageHeaders } from "features/common/fragments";
import { policyData } from "features/insuranceDocument/edit/policy/policyData/fragments";

export const POLICY_DATA_SAVED = gql`
  subscription policyDataSaved($documentId: Int!) {
    policyDataSaved(documentId: $documentId) {
      policyData {
        ...policyData
      }
      silentMode
      headers {
        ...messageHeaders
      }
    }
  }
  ${policyData}
  ${messageHeaders}
`;

export const OFFER_QUOTATION_RESET = gql`
  subscription offerQuotationReset {
    offerQuotationReset {
      documentId
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const QUOTATIONS_STATUS_CHANGED = gql`
  subscription quotationsStatusChanged($documentId: Int!) {
    quotationsStatusChanged(documentId: $documentId) {
      documentId
      quotationsStatus
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const DOCUMENT_UPDATED = gql`
  subscription documentUpdated($documentId: Int!, $userId: Int!) {
    documentUpdated(documentId: $documentId, userId: $userId) {
      documentId
    }
  }
`;

export const SERVER_COMPONENT_RESET = gql`
  subscription serverComponentReset {
    serverComponentReset {
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;
